import { render, staticRenderFns } from "./dispose.vue?vue&type=template&id=50864d3e&scoped=true&"
import script from "./dispose.vue?vue&type=script&lang=js&"
export * from "./dispose.vue?vue&type=script&lang=js&"
import style0 from "./dispose.vue?vue&type=style&index=0&id=50864d3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50864d3e",
  null
  
)

export default component.exports